_affirm_config = {
    public_api_key:  "OD1O1GQ3Q4RN1XS4",
    script:          "https://cdn1.affirm.com/js/v2/affirm.js"
  };
  (function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,_affirm_config,"affirm","checkout","ui","script","ready");

  (function () {
    function addAprLabel() {
      document.querySelectorAll('.affirm-as-low-as .__affirm-logo:not(.affirm-apr-ready)').forEach(function (logo) {
        var text = logo.previousSibling;
        if (!text || text.nodeType !== Node.TEXT_NODE || !/with\s*$/i.test(text.nodeValue)) return;

        text.nodeValue = text.nodeValue.replace(/with\s*$/i, '');
        logo.insertAdjacentHTML('beforebegin', '<span class="affirm-apr-label">APR</span> with ');
        logo.classList.add('affirm-apr-ready');
      });
    }

    addAprLabel();
    new MutationObserver(addAprLabel).observe(document.documentElement, { childList: true, subtree: true });
  })();
 // Use your live public API Key and https://cdn1.affirm.com/js/v2/affirm.js script to point to Affirm production environment.
